import type { InternalRequest } from '../client.js';

type Params = Record<string, string | number | boolean | undefined | null>;

function qsFrom(params?: Params): string {
  if (!params) return '';
  const entries = Object.entries(params).filter(([, v]) => v != null && v !== '');
  if (!entries.length) return '';
  const usp = new URLSearchParams();
  for (const [k, v] of entries) usp.set(k, String(v));
  return `?${usp}`;
}

export function chatEndpoints(req: InternalRequest) {
  return {
    conversations: {
      list: () => req.request<unknown[]>('/chat/conversations'),
      create: (data: Record<string, unknown>) =>
        req.request<unknown>('/chat/conversations', {
          method: 'POST',
          body: JSON.stringify(data),
        }),
    },
    messages: {
      list: (conversationId: string, params?: Params) =>
        req.request<unknown[]>(`/chat/conversations/${conversationId}/messages${qsFrom(params)}`),
      send: (conversationId: string, data: Record<string, unknown>) =>
        req.request<unknown>(`/chat/conversations/${conversationId}/messages`, {
          method: 'POST',
          body: JSON.stringify(data),
        }),
    },
    contacts: {
      list: () => req.request<unknown[]>('/chat/contacts'),
    },
    unreadCount: () => req.request<{ count: number }>('/chat/unread-count'),
    markRead: (conversationId: string) =>
      req.request<unknown>(`/chat/conversations/${conversationId}/read`, { method: 'PUT' }),
    broadcasts: {
      list: () => req.request<unknown[]>('/chat/broadcasts'),
      send: (data: Record<string, unknown>) =>
        req.request<unknown>('/chat/broadcasts', {
          method: 'POST',
          body: JSON.stringify(data),
        }),
    },
  };
}
